import React, { useEffect, useState } from "react";
import { fetchQuestionPaperApi } from "../../../services/service";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import useGateTestStyles from "../testStyle/gateStyle/gateTestStyle";


function QuestionPaper({ withAnswers = false }) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = useGateTestStyles(); // Use the styles


  const fetchQuestionPaper = async () => {
    const examId = sessionStorage.getItem("examId");
    try {
      setLoading(true);
      const response = await fetchQuestionPaperApi(examId);
      setQuestions(response.questions);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestionPaper();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "200px",
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="textSecondary">
          Loading question paper...
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {questions && questions.length > 0 ? (
        questions.map((question, qIndex) => (
          <Box
            sx={{
              // width: "100%",
              padding: { xs: 1, sm: 2 },
              borderBottom: "1px solid #eee"
            }}
            key={qIndex}
            mb={3}
          >
            {/* Question */}
            <p style={{ fontWeight: "bold", color: "black", marginBottom: "10px" }}>
              Question No. {qIndex + 1}
            </p>

            <div
              className={classes.img}
              dangerouslySetInnerHTML={{ __html: question.question_en }}
            />

            <Box
              sx={{
                color: "black",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1, sm: 3 },
                marginBottom: "15px",
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                bgcolor: { xs: "#f5f5f5", sm: "transparent" },
                p: { xs: 1, sm: 0 },
                borderRadius: "4px",
                border: { xs: "1px solid #ddd", sm: "none" }
              }}
            >
              <Box>
                <Typography component="span" fontWeight="bold" fontSize="inherit">Type:</Typography>{" "}
                {question.question_type === "Range" ? "Fill In The Blanks" : question.question_type}
              </Box>
              <Box>
                <Typography component="span" fontWeight="bold" fontSize="inherit" sx={{ color: "green" }}>Correct Marks:</Typography>{" "}
                {question.mark}
              </Box>
              <Box>
                <Typography component="span" fontWeight="bold" fontSize="inherit" sx={{ color: "red" }}>Negative Marks:</Typography>{" "}
                {question.negative_mark}
              </Box>
            </Box>

            {/* Options */}
            {(question.question_type !== "Fill In The Blanks" && question.question_type !== "Range") && (
              <Box display="flex" flexDirection="column" gap={1}>
                {question.options.map((option, oIndex) => (
                  <Box
                    key={oIndex}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                      "& img": {
                        maxWidth: { xs: "150px !important", sm: "300px !important" },
                        height: "auto !important",
                        objectFit: "contain",
                        verticalAlign: "middle",
                      },
                      display: "flex",
                      alignItems: "flex-start", // Changed to flex-start for multi-line options
                      paddingBottom: 1.5,
                      gap: 1.5,
                      fontSize: { xs: "0.9rem", sm: "1rem" }
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      {oIndex + 1}
                    </span>{" "}
                    <Box dangerouslySetInnerHTML={{ __html: option.option_en }} />
                  </Box>
                ))}
              </Box>
            )}

            {/* Correct Answers if withAnswers = yes */}
            {withAnswers === "yes" && (
              <div>
                {(question.question_type !== "Fill In The Blanks" && question.question_type !== "Range") ? (
                  <Box display="flex" flexDirection="column" gap={1}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Correct Answer
                    </span>{" "}
                    {question.options.map(
                      (option, oIndex) =>
                        option.correct_option && (
                          <Box
                            key={oIndex}
                            display="flex"
                            alignItems="center"
                            gap={1}
                            sx={{
                              "& img": {
                                width: "50px",
                                height: "50px",
                                objectFit: "contain",
                              },
                              display: "flex",
                              alignItems: "center",
                              paddingBottom: 1,
                            }}
                          >
                            <span style={{ fontWeight: "bold", color: "black" }}>
                              {oIndex + 1}
                            </span>{" "}
                            <Box
                              dangerouslySetInnerHTML={{
                                __html: option.option_en,
                              }}
                            />
                          </Box>
                        )
                    )}
                  </Box>
                ) : (
                  <Box style={{ fontWeight: "bold", color: "black" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Correct Answer
                    </span>{" "}
                    {question.options[0].solution_en}
                  </Box>
                )}
              </div>
            )}
          </Box>
        ))
      ) : (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body1" color="textSecondary">
            No questions available in this question paper.
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default QuestionPaper;
